import { GlobalStylesProps } from '@mui/system'

const globalStyles: GlobalStylesProps['styles'] = {
  '*': {
    boxSizing: 'border-box',
    fontSize: '14px'
  },
  // Tells the browser which way its own chrome should be painted: scrollbars,
  // native selects, autofill. Without it a dark theme still gets light native
  // scrollbars — a bright white bar under every table.
  "html[data-theme='dark']": {
    colorScheme: 'dark',
  },
  "html[data-theme='light']": {
    colorScheme: 'light',
  },
  html: {
    margin: 0,
    padding: 0,
    width: '100%',
    height: '100%',
    WebkitOverflowScrolling: 'touch'
  },
  body: {
    margin: 0,
    padding: 0,
    width: '100%',
    height: '100%'
  },
  '#root': {
    width: '100%',
    height: '100%'
  },
  input: {
    '&[type=number]': {
      MozAppearance: 'textfield',
      '&::-webkit-outer-spin-button': {
        margin: 0,
        WebkitAppearance: 'none'
      },
      '&::-webkit-inner-spin-button': {
        margin: 0,
        WebkitAppearance: 'none'
      }
    }
  },
  img: {
    display: 'block',
    maxWidth: '100%'
  },
  ul: {
    margin: 0,
    padding: 0
  }
}

export default globalStyles
